import LocomotiveScroll from 'locomotive-scroll';
//import { gsap, TweenLite, TweenMax, Linear, Back, Elastic, TimelineMax, TimelineLite, Power1, Power4 , Power2, Power3} from "gsap";
import { gsap, TweenMax, Power1, Power2, Power3} from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { Draggable } from "gsap/Draggable";
import { SplitText } from "gsap/SplitText";
//import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
//import { CustomEase } from "gsap/CustomEase";
import { InertiaPlugin } from "gsap/InertiaPlugin";
//import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import barba from '@barba/core';
//gsap.registerPlugin(CSSRulePlugin, DrawSVGPlugin, Draggable, SplitText,ScrollToPlugin, ScrollTrigger, MorphSVGPlugin, CustomEase, InertiaPlugin, TweenMax);


gsap.registerPlugin(CSSRulePlugin, Draggable, SplitText, ScrollTrigger, TweenMax, InertiaPlugin);



(function( $ ) {


    var locoScroll;
	function initScroll(){
		
		initSplitText();
		let options = {
			el: document.querySelector('.scroller'),
			smooth: true,
			lerp:0.15,
			multiplier:1,
			touchMultiplier:2.3,
			getSpeed: true,
			getDirection: true,
			smoothTouch: false,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			smartphone: {
				smooth: true
			},
			reloadOnContextChange: true
		}

		locoScroll = new LocomotiveScroll(options);
        

		//locoScroll.on("scroll", ScrollTrigger.update);
		locoScroll.on("scroll", updateScroll);

		
		//locoScroll.on("scroll", menuspecialsfixedScroll);


		ScrollTrigger.scrollerProxy(".scroller", {
			scrollTop(value) {
				return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
			},
			getBoundingClientRect() {
				return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
			}
		});

		$("body").on("click", "a[href^='#']", function(e){

   			e.preventDefault();
			const target = $(this).attr("href");
			if($(target).length){

				locoScroll.scrollTo(target, {

					offset: -60,

					duration: 1000

				});

			}

		});

        initParallax();
        initSliders();
		initLazyLoad();
	}


    function updateScroll(args){
        var y = args.scroll.y;
		var x = args.scroll.x;
        headerScroll(args);
		lazyLoad(y,x);


    }

	function initLazyLoad(){
		lazyLoad(0,0);
	}

	//LAZY LOAD 
	function lazyLoad(y,x){
		var winH = $("body").outerHeight();
		var winW = $("body").outerWidth();
		
		
		$("img[data-lazy-src]").each(function(i){
			
			var loaded = false;
			if($(this).hasClass("-loaded")){
				var loaded = true;
			}
			if(($(this).offset().top < (winH*1)) && ($(this).offset().top+$(this).outerHeight() > (winH*-0.02)) && ($(this).offset().left < (winW*1.02)) && ($(this).offset().left+$(this).outerWidth() > (winW*-0.02))){
				$(this).addClass("-in-view");
				if(!loaded){
					var lazysrc = $(this).attr("data-lazy-src");
					var lazysrcmobile = lazysrc;
					if ($(this).attr('data-lazy-src-mobile') !== undefined) {
						lazysrcmobile = $(this).attr("data-lazy-src-mobile");
					}
					var src = $(this).attr("src");
					if(winW < 767){
						lazysrc = lazysrcmobile;
					}
					if(lazysrc != src){
						$(this).on("load", function() {
							$(this).addClass("-loaded");
						}).attr("src", lazysrc);
					}
					else{
						$(this).addClass("-loaded");
					}
				}
			}
			else{
				$(this).removeClass("-in-view");
			}
			
		});
	}

	$(window).on("resize", function(){
		initLazyLoad();
	});

	let scrollDirection = "down";
	let pxScrolledStart = 0;
	let pxScrolledInDirection = 0;
	
	function headerScroll(args){
		
        /*let scrollTop = args.scroll.y;
        var header = $(".header");
        var headerBG = $(".header .bg2");
		var winW = $(window).width();
		
		if(scrollDirection == args.direction){
			if(scrollDirection == "down"){
				pxScrolledInDirection = args.scroll.y-pxScrolledStart;
			}
			else{
				pxScrolledInDirection = pxScrolledStart-args.scroll.y;
			}
			
		}
		else{
			scrollDirection = args.direction;
			pxScrolledStart = args.scroll.y;
			pxScrolledInDirection = 0;
		}

		if(scrollTop < 72){
			if(scrollDirection == "up"){
				gsap.set(header, {y:0});
			}
			else{
				gsap.set(header, {y:0-(scrollTop*1)});
			}
			//gsap.set(headerBG, {opacity:0});
			
			
		}
		else{
			gsap.set(headerBG, {opacity:1});
			if(scrollDirection == "up"){
				var pos = -72+pxScrolledInDirection;
				if(pos > 0){
					pos = 0;
				}
				gsap.set(header, {y:pos});
			}
			if(scrollDirection == "down"){
				var pos = 0-pxScrolledInDirection;
				if(pos < -72){
					pos = -72;
				}
				gsap.set(header, {y:pos});
			}
			
		}

		
		/*
		if(winW > 767){
			if(scrollTop < 160){
				gsap.set(header, {height:80-(scrollTop*0.1)});
				gsap.set(headerBG, {opacity:(scrollTop/160)});
			}
			else{
				gsap.set(header, {height:64});
				gsap.set(headerBG, {opacity:1});
			}
		}
		else{
			if(scrollTop < 160){
				gsap.set(header, {height:72-(scrollTop*0.075)});
				gsap.set(headerBG, {opacity:(scrollTop/160)});
			}
			else{
				gsap.set(header, {height:60});
				gsap.set(headerBG, {opacity:1});
			}
		}*/
		

    }
	

    function headerScrollReset(){
        var header = $(".header");
        var headerBG = $(".header .bg2");
		var winW = $(window).width();

		if(winW > 767){
        	gsap.to(header, {height:72,duration:0.4,ease:Power2.easeInOut});
		}
		else{
			gsap.to(header, {height:72,duration:0.4,ease:Power2.easeInOut});
		}
        gsap.to(headerBG, {opacity:0,duration:0.4,ease:Power2.easeInOut});
    }




    function initParallax(){
		
       


    }

    



    //BARBA PAGE TRANSITIONS
	barba.init({
		cacheIgnore: false,
		prefetchIgnore: false,
		transitions: [{
			name: 'opacity-transition',
			leave(data) {
                headerScrollReset();
                
                //console.log(data);
                const tl = gsap.timeline();

                /*tl.to(".hero_background", {
                    y: -80,
					opacity:0,
                    duration:0.6,
                    ease:Power2.easeInOut
                });*/

				const tl2 = gsap.timeline();

                tl2.to(data.current.container, {
                    opacity:0,
                    duration:0.3,
                    ease:Power2.easeInOut
                });

				
                
                return tl2;

                
			},
            beforeEnter(data){
                
                
                
                //initNav(data.next.namespace);
				//gsap.set(data.next.container, { opacity:0});
                //gsap.set(data.next.container, { y:"300px"});
			},
			enter(data) {
                
                //locoScroll.destroy();
                
                const tl2 = gsap.timeline();
                /*tl2.to(".page-transition .slide", {
                    y:"-100%",
                    duration:0.6,
                    delay:0,
                    ease:Power2.easeInOut
                });
				/*const tl = gsap.timeline(); */
                tl2.from(data.next.container, {
                    opacity:0,
                    duration:0.3,
                    delay:0,
                    ease:Power2.easeInOut
                }); 
				
                
                
			},
			after() {
				initScroll();
				//initNav2();
				initSliders();
				headerScrollReset();
                //setTimeout(function(){
                    
                //},1000);
                //gsap.set(".page-transition .slide", { height:"100%", y:"100%", delay:0.6});
                
                
                
			},
		}]
	});




   /*SPLIT TEXT */
	var splitArray = [];
	var split;
	var split2;
	var split3;
	function initSplitText() {
		var winW = $(window).width();
		splitArray = [];
		if(winW < 1024){
			return false;
		}
		$(".-split-lines").each(function(i, el){
			split3 = new SplitText(el, { type: "lines", linesClass: "-l-inside" });
		});

		//split text
		$(".-text-animation").each(function(i, el){
			var staggerAttr = $(el).attr('text-animation-stagger');
			if (typeof staggerAttr !== 'undefined' && staggerAttr !== false) {
				var stagger = staggerAttr;
			}
			else{
				var stagger = 0.08;
			}

			var delayAttr = $(el).attr('text-animation-delay');
			if (typeof delayAttr !== 'undefined' && delayAttr !== false) {
				var delay = delayAttr;
			}
			else{
				var delay = 0;
			}

			var durationAttr = $(el).attr('text-animation-duration');
			if (typeof durationAttr !== 'undefined' && durationAttr !== false) {
				var duration = durationAttr;
			}
			else{
				var duration = 0.2;
			}

			var positionAttr = $(el).attr('text-animation-position');
			if (typeof positionAttr !== 'undefined' && positionAttr !== false) {
				var position = positionAttr;
			}
			else{
				var position = "top 100%";
			}


			if($(el).hasClass("-lines")){
				//split2 = nestedLinesSplit($(el), {type:"lines", linesClass: "-l-outside" });
				//split = nestedLinesSplit($(el), {type:"lines", linesClass: "-l-inside" });
				//splitArray.push(split);
				if($("p",el).length){
					el = $("p", el);
				}
				split = new SplitText(el, { type: "lines", linesClass: "-l-inside" });


				const splitTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $(el)[0],
						start: position,
						scroller: ".scroller",
						end: "bottom top",
						//onToggle: self => gsap.to(el, {opacity: self.isActive ? 1 : 0}),
						//toggleActions: "play none none none",
						markers: false,
						stagger: stagger,
						ease: "power3.easeIn"
					}
				});


				splitTimeline.from(split.lines, {
					duration: duration,
					opacity: 0,
					y: "40%",
					scale: 1,
					yoyo: false,
					stagger: stagger,
					//toggleActions: "play none none none",
					delay:delay,
					ease: "power3.easeIn",
				});
			}
			if($(el).hasClass("-words")){
				//const split2 = nestedLinesSplit($(el), {type:"words", wordsClass: "-w-outside" });
				//const split = nestedLinesSplit($(el), {type:"words", wordsClass: "-w-inside" });
				if($("p",el).length){
					el = $("p", el);
				}

				var split = new SplitText(el, { type: "words", linesClass: "-w-inside" });



				const splitTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $(el)[0],
						start: position,
						scroller: ".scroller",
						end: "bottom top",
						onToggle: self => gsap.to(el, {opacity: self.isActive ? 1 : 0}),
						toggleActions: "play none none none",
						markers: false,
						stagger: stagger,
						ease: "power3.easeInOut"
					}
				});


				splitTimeline.from(split.words, {
					duration: duration,
					opacity: 0,
					y: "30%",
					scale: 1,
					yoyo: false,
					stagger: stagger,
					delay:delay,
					ease: "power3.easeInOut",
				});


			}
		});


	}



	//menu link animation
	$("body").on("click", ".main-menu .menu-list li a", function(){
		var b = $(".main-menu .menu-list li.-active a .l");
		gsap.to(b, {width:"0%",duration:0.3, ease: Power2.easeOut});
		var l = $(".l", this);
		gsap.to(l, {width:"100%",duration:0.3, ease: Power2.easeOut});
	});

	//menu submenu animation
	$("body").on("mouseenter", ".main-menu .menu-list li.-has-submenu", function(){
		console.log("asdf");
		var b = $(".submenu", this);
		console.log(b);
		gsap.to(b, {y:"0%",duration:0.4, ease: Power2.easeOut});
	});
	$("body").on("mouseleave", ".main-menu .menu-list li.-has-submenu", function(){
		console.log("asdf");
		var b = $(".submenu", this);
		gsap.to(b, {y:"-100%",duration:0.3, ease: Power2.easeOut});
	});
	

    /////////////
    //mobile menu
    /////////////

    $("body").on("click", ".responsive-menu:not(.-open)", function(){
		openResponsiveMenu();
    });
	$("body").on("click", ".responsive-menu.-open", function(){
        closeResponsiveMenu();
    });
	$("body").on("click", ".mobile-menu div[data-barba-link]", function(e){
		const href = $(this).attr('href');
		closeResponsiveMenu();
		if (
			!href ||
			href.startsWith('#') ||
			href.startsWith('mailto:') ||
			href.startsWith('tel:') ||
			this.target === '_blank'
		) {
			return;
		}
		setTimeout(function () {
			barba.go(href);
		}, 300);
        
    });
	$("body").on("click", ".mobile-menu .mobile-menu-blur", function(){
        closeResponsiveMenu();
    });

	function openResponsiveMenu(){
		$(".responsive-menu").addClass("-open");
		gsap.set($(".mobile-menu"), {opacity:1,pointerEvents:"all"});
		gsap.to($("header.header .mobile-menu-blur"), {opacity:1,duration:1, ease: Power2.easeOut});
		gsap.to($("header.header .mobile-menu-bg"), {y:0, height:400, duration:1, ease: Power2.easeInOut});
		gsap.to($("main"), {y:30,scale:1, duration:1, ease: Power2.easeInOut});
		$(".mobile-menu .menu-list li div[data-barba-link]").each(function(i, el){
			var delay = 0.1*(i+1)+0.5;
			gsap.to($(el), {y:0, duration:0.8, delay:delay, ease: Power2.easeOut});
		});
	}

	function closeResponsiveMenu(){
		$(".responsive-menu").removeClass("-open");
		gsap.to($("header.header .mobile-menu-blur"), {opacity:0,duration:1, ease: Power2.easeInOut});
		gsap.to($("header.header .mobile-menu-bg"), {y:"-100%",duration:1, delay:0, ease: Power2.easeInOut});
		gsap.to($("main"), {y:0,scale:1,duration:1, ease: Power2.easeInOut});
		$(".mobile-menu .menu-list li div[data-barba-link]").each(function(i, el){
			var delay = 0*(i+1)+0;
			gsap.to($(el), {y:"32px", duration:0.4, delay:delay, ease: Power2.easeIn});
		});
		gsap.set($(".mobile-menu"), {opacity:0,pointerEvents:"none",delay:1});

	}
	
   
    
    



    //modal 

    function openModal(modalName){
		var modal = $("#modal__overlay");
		gsap.set(
			$(".modal-container", modal), 
			{opacity:0, zIndex:1},
		);
		gsap.set($(modal), {"display": "block"});
		gsap.fromTo(
			$(".bg", modal), 
			{opacity:0},
			{opacity:1, duration:1, delay:0, ease:Power3.easeOut},
		);
		gsap.fromTo(
			$("#modal-"+modalName, modal), 
			{opacity:0, zIndex:11, marginTop:"10px"},
			{opacity:1, duration:1, zIndex:11, marginTop:"0px", delay:0.5, ease:Power3.easeOut},
		);
	}

	function closeModal(){
		var modal = $("#modal__overlay");
		gsap.to(
			$(".bg", modal), 
			{opacity:0, delay:0, duration:0.5, ease:Power3.easeOut, onComplete:function(){ gsap.set($(modal), {"display": "none"}) }},
		);
		gsap.to(
			$(".modal-container", modal), 
			{opacity:0, duration:0.5, delay:0, zIndex:1, marginTop:"10px", ease:Power3.easeOut},
		);
		
	}

    //COOKIES
	var acceptedCookies = localStorage.getItem("accepted-cookies");
	if(acceptedCookies === null){
		showCookieNotification();
	}
	else{
		var cookieTime2 = parseInt(acceptedCookies);
		if(cookieTime2+(3600*1000*24*30) < Date.now()){
			showCookieNotification();
		}
	}
	$("body").on("click", ".cookies-container a", function(e){
		e.preventDefault();
		hideCookieNotification();
		localStorage.setItem("accepted-cookies", Date.now());
	});

	function showCookieNotification(){
		var a = $("#cookies__overlay .cookies-container");
		$("#cookies__overlay").addClass("-show");
		gsap.from(a, {opacity:0, y:20,ease:Power3.easeOut,duration:0.5});
	}
	function hideCookieNotification(){
		var a = $("#cookies__overlay .cookies-container");
		
		gsap.to(a, {opacity:0, y:20,ease:Power3.easeOut,duration:0.4});
		setTimeout(function(){
			$("#cookies__overlay").removeClass("-show");
		},400);
	}


	$("body").on("click", "#book-button", function(e){
		//e.preventDefault();
		openBookingsModule();
	});

	$("body").on("click", ".booking_overlay .bg", function(e){
		//e.preventDefault();
		closeBookingsModule();
	});

	

	function openBookingsModule(){
		var html = $(".booking_box").html();
		$(".booking_overlay .el").html(html);
		$(".booking_overlay").addClass("-show");

		var this2 = $(".booking_box .booking_element");
		var y = $(this2).offset().top;
		var x = $(this2).offset().left;
		var w = $(this2).outerWidth();
		var h = $(this2).outerHeight();

		gsap.set($(".booking_overlay .booking_element"), {left:x,top:y,width:w,height:h});
		gsap.to($(".booking_overlay .booking_element"), {top:"5%",left:"5%", width:"90%", height:"90%", duration:1, delay:0, ease:Power3.easeInOut});
		gsap.to($(".booking_overlay .bg"), {opacity:1, duration:1.5, delay:0, ease:Power3.easeInOut});
	}

	function closeBookingsModule(){
		var html = $(".booking_overlay .el .booking_element").html();
		$(".booking_box").html('<div class="booking_element">'+html+'</div>');

		setTimeout(function(){
			$(".booking_overlay").removeClass("-show");
		},600);

		var this2 = $(".booking_box .booking_element");
		var y = $(this2).offset().top;
		var x = $(this2).offset().left;
		var w = $(this2).outerWidth();
		var h = $(this2).outerHeight();
		gsap.to($(".booking_overlay .booking_element"), {top:y,left:x, width:w, height:h, background:"rgba(255,255,255,0)",duration:0.6, delay:0, ease:Power3.easeInOut});
		gsap.to($(".booking_overlay .bg"), {opacity:0, duration:0.6, delay:0, ease:Power3.easeInOut});
	}




	

	//SLIDER
	function initSliders(){
		if($(".slider").length > 0){
			///DRAGGABLE SLIDER
			$(".slider").each(function(i,v){
				var container = $(this).parent();
				var nSlides = $(".slide", this).length;
				var slideWidth = $(".slide", this).width();

				var sliderWidth = nSlides*slideWidth;
				$(this).width(sliderWidth);
				Draggable.create(this, {
					edgeResistance: 0.85,
					type: "x",
					inertia: true,
			    	autoScroll: true,
					lockAxis: true,
					bounds: container,
					throwProps:true, 
					onMove: function(a) {
						sliderParallax(this);
						
					},
					onThrowUpdate: function(){
						sliderParallax(this);
					},
					onDragEnd: function() {
						sliderParallax(this);
					}
				});
			});

		}
	}

	function sliderParallax(slider){
		var y = locoScroll.scroll.instance.scroll.y;
		var x = locoScroll.scroll.instance.scroll.x;
		lazyLoad(y,x);
		var sliderX = slider.x*-1;
		var sliderEl = $(slider.target)[0];
		var sliderID = $(sliderEl).attr("data-slider-id");
		var sliderButtonsEl = $("[data-slider-id-buttons='"+sliderID+"'");
		var sliderWidth = $(slider.target).width();
		var sliderContainerWidth = $(slider.target).parent().width();
		var slides = $(".slide", sliderEl).length;
		var slideWidth = sliderWidth/slides;

		if(sliderX > 0){
			$(".-prev.-disabled", sliderButtonsEl).removeClass("-disabled");
		}
		if(sliderX < 0){
			$(".-prev:not(.-disabled)", sliderButtonsEl).addClass("-disabled");
		}

		if(sliderX+sliderContainerWidth > sliderWidth){
			$(".-next:not(.-disabled)", sliderButtonsEl).addClass("-disabled");
		}
		if(sliderX+sliderContainerWidth < sliderWidth){
			$(".-next.-disabled", sliderButtonsEl).removeClass("-disabled");
		}
		

		/*var sliderWidth = $(slider.target).width();
		var slides = $(".slide", slider.target).length;
		var slideWidth = sliderWidth/slides;
		console.log(slideWidth);
		var absSlidePos = -(Math.ceil(slider.x/slideWidth))+1;
		var relSlidePerc = Math.abs(slider.x/slideWidth)-(absSlidePos-1);
		var relSlidePercEase = easeInCubic(relSlidePerc);
		$(".slide:nth-child("+absSlidePos+")", slider.target).css({"transform": "translate("+(-relSlidePercEase*20)+"%, 0)"});*/
	}

	$("body").on("click", ".slider-buttons .slider-button.-next:not(.-disabled)", function(e){
		var sliderButtonsEl = $(this).parent("[data-slider-id-buttons]");
		$(".-prev.-disabled", sliderButtonsEl).removeClass("-disabled");
		var sliderID = $(sliderButtonsEl).attr("data-slider-id-buttons");
		var sliderEl = $("[data-slider-id='"+sliderID+"'");
		var sliderX = $(sliderEl).position().left*-1;
		var sliderWidth = $(sliderEl).width();
		var sliderContainerWidth = $(sliderEl).parent().width();
		var slides = $(".slide", sliderEl).length;
		var slideWidth = sliderWidth/slides;
		var currentSlide = Math.floor(sliderX/slideWidth);
		var nextSlide = currentSlide+1;
		var nextPos = (nextSlide)*slideWidth;
		if(nextPos > (sliderWidth-sliderContainerWidth)){
			nextPos = sliderWidth-sliderContainerWidth;
			$(this).addClass("-disabled");
		}
		gsap.to(sliderEl, {x:-nextPos,duration:1,ease:Power3.easeInOut});
	});


	$("body").on("click", ".slider-buttons .slider-button.-prev:not(.-disabled)", function(e){
		var sliderButtonsEl = $(this).parent("[data-slider-id-buttons]");
		$(".-next.-disabled", sliderButtonsEl).removeClass("-disabled");
		var sliderID = $(sliderButtonsEl).attr("data-slider-id-buttons");
		var sliderEl = $("[data-slider-id='"+sliderID+"'");
		var sliderX = $(sliderEl).position().left*-1;
		var sliderWidth = $(sliderEl).width();
		var sliderContainerWidth = $(sliderEl).parent().width();
		var slides = $(".slide", sliderEl).length;
		var slideWidth = sliderWidth/slides;
		var currentSlide = Math.ceil(sliderX/slideWidth);
		var nextSlide = currentSlide-1;
		var nextPos = (nextSlide)*slideWidth;
		if(nextPos <= 0){
			nextPos = 0;
			$(this).addClass("-disabled");
		}
		//console.log(sliderX, nextPos, sliderWidth, sliderContainerWidth, currentSlide);
		gsap.to(sliderEl, {x:-nextPos,duration:1,ease:Power3.easeInOut});
	});




	



    
    function initPage(){
        
        initScroll();
		//initNav();
		initSliders();
    }
    initPage();


	function easeInCubic(x){
		return x * x * x;
	}
	

} ) ( jQuery );




